import { Injectable } from '@angular/core';
import { QueryEntity } from '@examdojo/state';
import { SourceStoreModel, SourceUIModel } from './source.model';
import { SourceState, SourceStore } from './source.store';

@Injectable({ providedIn: 'root' })
export class SourceQuery extends QueryEntity<SourceState, SourceStoreModel, SourceUIModel, 'id'> {
  constructor(protected override readonly store: SourceStore) {
    super(store);
  }
}
